import { SET_ANALYTICS_PLATFORM_CHANNEL } from '../../reducers/analyticsPlatform';
import { getAnalyticsPlatformChannel } from '../../helpers/getAnalyticsPlatformChannel';

const setAnalyticsPlatformChannel = () => async dispatch => {
  const channel = await getAnalyticsPlatformChannel();

  dispatch({
    type: SET_ANALYTICS_PLATFORM_CHANNEL,
    channel,
  });
};

export default setAnalyticsPlatformChannel;
